<template>
  <div class="sticky-bottom-mobile">
    <div class="flex xs-hide flex-wrap justify-center items-start total-bar">
      <div class="flex full-height col-12 dark-blue-bg white border-white">
        <span class="flex full-height sm-col-6 col-6 py2 pl4 items-center h3">Total</span>
        <div class="flex flex-column full-height sm-col-6 col-3 py2 pr2 justify-center items-center h3">
          <span v-if="total > totalWithCampaign" class="crossed">{{ total }} €</span>
          <span>{{ totalWithCampaign }} €</span>
        </div>
        <span class="flex full-height xs-hide col-3 py2 justify-center items-center red-bg caps h5 pointer border-lw" :class="[{disabled: !canAdvance}]" @click="confirmFunction()">Continuer</span>
      </div>
    </div>
    <div class="flex col-12-vw lg-hide md-hide sm-hide justify-center items-center dark-blue-bg white total-bar p2 justify-between footer-margin full-height">
      <span class="flex col-2 h3">Total</span>
      <span class="flex col-5 justify-center h3">{{ totalWithCampaign }} €</span>
      <span class="flex col-5 p1 justify-center red-bg caps h6 pointer" :class="[{disabled: !canAdvance}]" @click="confirmFunction()">Continuer</span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    confirmFunction: {
      type: Function,
      default: () => {}
    },
    canAdvance: {
      type: Boolean,
      default: false
    },
    total: {
      type: String,
      default: ''
    },
    totalWithCampaign: {
      type: String,
      default: ''
    }
  }
};

</script>

<style lang="scss" scoped>

@media (min-width: 40em) {
  .total-bar {
    height: 72px;
  }
}
.total-bar {
  min-height: 88px;
  height: 88px;
}
.col-12-vw{
  width: 100vw;
}
.footer-margin{
  margin: 0 -1rem;
}
</style>
